export default "__VITE_ASSET__CdTZKv_X__"